import React from 'react';

const Counter = ({ label, value, onDecrement, onIncrement, className, theme = 'light' }) => {
  return (
    <div className={className}>
      <label className={`uppercase tracking-wide text-xs font-semibold mb-2 ${theme === 'light' ? 'text-gray-600' : 'text-gray-400'}`}>
        {label}
      </label>
      <div className={`flex flex-row h-10 w-full rounded-lg relative mt-1 ${theme === 'light' ? 'bg-transparent' : 'bg-transparent'}`}>
        <button
          type="button"
          onClick={onDecrement}
          className={`h-full w-20 rounded-l cursor-pointer px-2 ${theme === 'light'
              ? 'bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400'
              : 'bg-gray-700 text-gray-300 hover:text-white hover:bg-gray-600'
            }`}
        >
          <span className="m-auto text-2xl">−</span>
        </button>
        <input
          readOnly
          type="number"
          className={`text-center w-full font-semibold text-md md:text-base cursor-default flex items-center ${theme === 'light'
              ? 'bg-gray-200 text-gray-600 hover:text-black focus:text-black'
              : 'bg-gray-700 text-gray-200 hover:text-white focus:text-white'
            }`}
          value={value}
        />
        <button
          type="button"
          onClick={onIncrement}
          className={`h-full w-20 rounded-r cursor-pointer px-2 ${theme === 'light'
              ? 'bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400'
              : 'bg-gray-700 text-gray-300 hover:text-white hover:bg-gray-600'
            }`}
        >
          <span className="m-auto text-2xl">+</span>
        </button>
      </div>
    </div>
  );
};

export default Counter;
